var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidationError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.063,
    height: 29.063,
    viewBox: "0 0 29.063 29.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF1721",
    id: "ico-warning",
    d: "M0-25.781A14.533,14.533,0,0,0-14.531-11.25,14.53,14.53,0,0,0,0,3.281,14.53,14.53,0,0,0,14.531-11.25,14.533,14.533,0,0,0,0-25.781ZM0,.469A11.712,11.712,0,0,1-11.719-11.25,11.715,11.715,0,0,1,0-22.969,11.715,11.715,0,0,1,11.719-11.25,11.712,11.712,0,0,1,0,.469ZM2.461-5.625A2.464,2.464,0,0,0,0-8.086,2.464,2.464,0,0,0-2.461-5.625,2.464,2.464,0,0,0,0-3.164,2.464,2.464,0,0,0,2.461-5.625ZM-2.307-18.012l.4,7.969a.7.7,0,0,0,.7.668H1.206a.7.7,0,0,0,.7-.668l.4-7.969a.7.7,0,0,0-.7-.738H-1.6A.7.7,0,0,0-2.307-18.012Z",
    transform: "translate(14.531 25.781)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationError);
export default __webpack_public_path__ + "static/media/validation-error.534dba0167bf7ced2b4e1b9152d958c5.svg";
export { ForwardRef as ReactComponent };